import React from "react";

const reviews = [
  {
    title: "Good Deal For The Price",
    text: "Had the French burger combo. Good burger, good fries. Great deal for the price. The car in front of me had a large order, making for a bit of wait but the man at the window was very apologetic about the delay.",
    author: "Rodney R.",
  },
  {
    title: "Great food and great people",
    text: "Great food and great people. Food is prepared very quickly. It's like magic. We have been coming here for many years and always order the French roll burger. The best ever!!!!",
    author: "Marinna M.",
  },
  {
    title: "You have to try their banana split",
    text: "Such delicious food. If you go there, you have to try their banana split. But beware, it isn't nut free. Support them. You'll thank me later.",
    author: "Tia M.",
  },
  {
    title: "Wide variety on the menu",
    text: "One of my favorite places to eat also they have a pound and a-half burger. Their milkshakes are one of the best in Sacramento. I would suggest that to anyone who have ever went there to go there. Have a wide variety on the menu from corn dogs sandwiches, burrito, hamburgers and more. This is one of the best Rio Linda places to ever eat.",
    author: "Rob C.",
  },
];

const ReviewCards = () => {
  return (
    <div className="reviewCards">
      <h2 className="py-4 text-center">Customer Reviews</h2>
      <div className="row justify-content-center">
        {reviews.map((review, index) => (
          <div key={index} className="col-md-3" data-aos="fade-left">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">"{review.title}"</h5>
                <p className="card-text">"{review.text}"</p>
                <p className="card-text text-right">{review.author}</p>
                <div className="pt-2 text-center">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="fas fa-star checked"></i>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewCards;


